import React from 'react';

type NewPatientBadgeProps = {
  /** Slightly smaller for dense queue cards. */
  size?: 'sm' | 'md';
};

/** Visit.NewPt — first-time patient at registration (CheckLine). */
export function NewPatientBadge({ size = 'md' }: NewPatientBadgeProps) {
  const fontSize = size === 'sm' ? 10 : 11;
  const padding = size === 'sm' ? '2px 8px' : '3px 10px';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding,
        borderRadius: 12,
        fontSize,
        fontWeight: 700,
        lineHeight: 1.2,
        background: '#fef2f2',
        color: '#991b1b',
        border: '1px solid #fca5a5',
        whiteSpace: 'nowrap',
      }}
    >
      New Patient
    </span>
  );
}
